export default __webpack_public_path__ + "static/media/sendBill.f0995160.jpg";